import { render } from "./ControlButton.vue?vue&type=template&id=7714ad1c&scoped=true&ts=true"
import script from "./ControlButton.vue?vue&type=script&lang=ts"
export * from "./ControlButton.vue?vue&type=script&lang=ts"

import "./ControlButton.vue?vue&type=style&index=0&id=7714ad1c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7714ad1c"]])

export default __exports__